import type { IModuleRowState } from './IModuleRowState';

/**
 * Чи показувати «Скинути» в рядку «Встановлених модулів» (рішення 2 етапу 9, як cmRows.canReset прототипу): модуль — перейменований чи
 * вимкнений у просторі (не глобально) або простір має перевизначення будь-якого типу модуля; дочірня таблиця — перевизначення цієї таблиці.
 * `overridden` каталогу — «скидання щось змінить»: перевизначення лише з доданими полями (customFields, їх скидання зберігає) — ні; тому й
 * власний модуль простору (ADR-025, поля якого — customFields) показує «Скинути» лише тоді, коли є що скидати. Чиста функція.
 */
export function canResetRow(s: IModuleRowState): boolean {
  if (!s.row.rt.main) return s.overridden;
  return s.renamed || (!s.enabled && !s.globalOff) || s.moduleOverridden;
}
